import { render } from "./OnboardingName.vue?vue&type=template&id=df1b4bb0"
import script from "./OnboardingName.vue?vue&type=script&lang=js"
export * from "./OnboardingName.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__